export default __webpack_public_path__ + "static/workspaces-037108bf78f785c013a9d9c147cc95d7.png";